<template>
  <section
    :data-background-video="videoUrl"
    :data-background-image="gifUrl"
    data-background-video-loop="true"
    data-background-opacity="0.4"
    :data-visibility="offlineUnits.length == 0 ? 'hidden' : ''"
  >
    <div
      class="sl-block"
      data-block-type="text"
      data-name="text-a86498"
      data-block-id="f5b989af7f6f90391c1972112bed8388"
      style="height: auto; left: -220px; top: -75.5px"
    >
      <div
        class="sl-block-content"
        data-placeholder-tag="p"
        data-placeholder-text="Text"
        style="z-index: 10; text-align: left; color: rgb(255, 255, 255)"
      >
        <ul>
          <li
            v-for="item in offlineUnits"
            :key="'exception_' + item.platformGroupName"
            style="padding-bottom: 20px; font-size: 0.9em; list-style: none"
          >
            <strong>{{ item.platformGroupName}}</strong>
            stopped responding {{ moment(item.lastCommandFetch).fromNow() }} <br />

          </li>
        </ul>
      </div>
    </div>
   
  </section>
</template>

<script>
import Trimaster from "@/plugins/servers/trimaster.js";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "",
  props: ["value"],
  components: {},
  beforeMount() {
     if (navigator.userAgent.indexOf("Silk") > 0) {
      this.gifUrl = "/img/presentationbackgrounds/redalert.gif";
    } else {
      this.videoUrl = "/img/presentationbackgrounds/redalert.mp4";
    }
      this.refresh();
  },
  mounted() {},
  data() {
    return {
      offlineUnits: [],
      gifUrl: null,
      videoUrl: null,
      moment: moment
    };
  },

  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {},
  methods: {
    refresh() {
      let me = this;
      Trimaster.get("facilities/getOfflineControllers", this.getUser.apitoken, {
        facility_id : this.getUser.facility_id,
      }).then(function ([res, err]) {
        let out = [];
        if (res.length > 5) {
            me.offlineUnits = res.slice(0,5);
        } else {
            me.offlineUnits = res;
        }
      });
    },
  },
};
</script>
<style>
#scorecardSlide td {
  font-size: 0.8em;
}
</style>

